import { render, staticRenderFns } from "./PaymentGateways.vue?vue&type=template&id=06560705&"
import script from "./PaymentGateways.vue?vue&type=script&lang=ts&"
export * from "./PaymentGateways.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports